'use client';

import * as React from 'react';
import { createContext, useContext, useMemo } from 'react';

interface Authentication {
  onAuthenticated: (token: string) => void;
}
interface AuthenticationProviderProps {
  children: React.ReactNode;
  onAuthenticated: (token: string) => void;
}

export const AuthenticationContext = createContext<Authentication>({} as Authentication);

const AuthenticationProvider = ({ children, onAuthenticated }: AuthenticationProviderProps) => {
  const value = useMemo(() => {
    return {
      onAuthenticated
    };
  }, [onAuthenticated]);

  return <AuthenticationContext.Provider value={value}>{children}</AuthenticationContext.Provider>;
};

export const useAuthentication = () => useContext<Authentication>(AuthenticationContext);

export default AuthenticationProvider;
